function createGaLabelsForRanges(arrOfRanges) {
  return function (num) {
    return arrOfRanges.reduce((currentRange, stringRange) => {
      return createIsInRange(stringRange)(num) ? stringRange : currentRange
    }, 'unknown')
  }
}

function createIsInRange(rangeString) {
  // 0-25
  const isRange = rangeString.indexOf('-') > -1
  // 300+
  const isMin = rangeString.indexOf('+') > -1
  // 3
  const isExact = !isMin && !isRange

  let min
  let max
  let exact

  if (isRange) {
    ;[min, max] = rangeString.split('-').map((strNum) => parseInt(strNum, 10))
  }

  if (isMin) {
    min = parseInt(rangeString, 10)
  }

  if (isExact) {
    exact = parseInt(rangeString, 10)
  }

  return function (num) {
    let isMatch = false
    if (max) {
      isMatch = num >= min && num <= max
    } else if (isExact) {
      isMatch = exact === num
    } else {
      isMatch = num >= min
    }
    return isMatch
  }
}

export { createGaLabelsForRanges }
